import {ReactNode, useEffect} from "react";

export default function Paginator({page, children, setPageCount}: { page: number, children: ReactNode[] | ReactNode, setPageCount: (count: number) => void }) {
    useEffect(() => {
        setPageCount(Array.isArray(children) ? children.filter(x => !!x).length : 1);
    }, [children]);


    return (<>
            {Array.isArray(children) ? children.filter(x => !!x)[page] : children}
        </>
    )

}